// Loyalty Modal 功能
document.addEventListener('DOMContentLoaded', function () {
    const modal = document.getElementById('loyalty-modal');
    const openButtons = document.querySelectorAll('.loyalty-banner__icon--right');
    const closeButton = document.querySelector('[data-loyalty-modal-close]');
    const overlay = document.querySelector('.loyalty-modal__overlay');

    if (!modal) return;

    function openModal() {
        modal.setAttribute('aria-hidden', 'false');
        modal.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
    }

    function closeModal() {
        modal.setAttribute('aria-hidden', 'true');
        modal.classList.remove('is-visible');
        document.body.style.overflow = '';
    }

    // 打开弹框
    openButtons.forEach(button => {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            openModal();
        });
    });

    // 关闭弹框
    if (closeButton) {
        closeButton.addEventListener('click', closeModal);
    }

    if (overlay) {

        overlay.addEventListener('click', closeModal);
    }

    // ESC 键关闭
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-visible')) {
            closeModal();
        }
    });
});